import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import { ItemType } from 'src/types';
import { theme } from 'src/utils/theme/minerva-main';

const {  minervaColors } = theme.palette;

interface MaterialTypeProps {
  type: ItemType;
}

const materialColor: { [key: string]: string } = {
  1: "#767d86",
  2: "#03408c",
  3: "#28cb86",
  4: "#AB7942",
  5: "#00FDFF",
  6: "#00FA00",
  7: "#FF40FF",
  8: "#EE0000",
};

const ContainerType = styled(Box)<{ type: number }>(({ type }) => ({
  backgroundColor: materialColor[type],
  color: minervaColors.primaryWhite,
  marginInline: theme.spacing(1),
  width: '100%',
  textAlign: 'center',
  borderRadius: 10,
}));

export default ({ type: { id, name } }: MaterialTypeProps) => {
  return <ContainerType type={id}>{name}</ContainerType>;
};
